import { render } from "./NonAssociatedProjects.vue?vue&type=template&id=a071b59c&scoped=true"
import script from "./NonAssociatedProjects.vue?vue&type=script&lang=js"
export * from "./NonAssociatedProjects.vue?vue&type=script&lang=js"

import "./NonAssociatedProjects.vue?vue&type=style&index=0&id=a071b59c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a071b59c"]])

export default __exports__